import { AppBar, Box, Container, Grid, IconButton,  Menu,  Toolbar } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { Toast } from "../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../libs/data-grid-view/useGridApiRef";
import { linear_content_style, linear_h, linear_item, linear_v, } from "../../../libs/linear-layout/LinearLayout";
import Title from "../../../libs/rhf-mui/ui/Title";
import {  ROUTE_project_list } from "../../Routes";
import Blocker from "../../components/Blocker";
import { Project } from "../../dao/Project";
import { ProjectDAO, useProject, useProjectList } from "../../dao/ProjectDAO";
import { R } from "../../R";
import TabPage from "../../components/TabPage";
import { DGV_LOCAL_TEXT, sx_icon_button } from "../../components/UIHelper";
import AppMenuButton from "../../components/AppMenuButton";
import { useEffect, useState } from "react";
import UcDgvCustomToolbar from "../../components/UcDgvCustomToolbar";
import UcDgvCustomPagination from "../../components/UcDgvCustomPagination";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreIcon from '@mui/icons-material/MoreVert';
import DateHelper from "../../heplers/DateHelper";
import Label from "../../../libs/rhf-mui/ui/Label";
import { useSearchParams } from "react-router-dom";


type Props = {};

const FrmProjectMerge = (props: Props) => {
  const [searchParams] = useSearchParams();// UrlQueryParams
  const project_guid = searchParams.get("project") ?? "";
  const { _Project } = useProject(project_guid);

  const ctx = useAppContext();
  const columns: GridColDef[] = [

    {
      field: "rec_dt", headerName: "健檢開始日", width: 150,
      valueGetter: (params) => { return (params.row as Project).get_RecDT_str(); },
    },
    { field: "cid", headerName: "cid", width: 150 },
    { field: "project_code", headerName: "場次編號", width: 150 },
    { field: "project_name", headerName: "場次名稱", width: 320 },
    { field: "cust_name", headerName: "客戶名稱", width: 320 },
    {
      field: "quest_start", headerName: "開放日期", width: 150,
      valueGetter: (params) => { return (params.row as Project).get_QuestStart_str(); },
    },
    {
      field: "quest_end", headerName: "截止日期", width: 150,
      valueGetter: (params) => { return (params.row as Project).get_QuestEnd_str(); },
    },

    { field: "account_rule", headerName: "帳號類別", width: 150 },
    { field: "password_rule", headerName: "密碼類別", width: 150 },
    { field: "end_dt", headerName: "結案日期", width: 150 },

  ];

  const grid_api = useGridApiRef(columns);
  const { _ProjectList } = useProjectList(true);
  const [projects, set_projects] = useState<Project[]>();
  const [AppBarTabIndex] = useState("Tab1");
  const [MenuPosition, set_MenuPosition] = useState<any>(null);
  const [MenuName, set_MenuName] = useState<any>(null);
  useEffect(() => {
    GetProject();
  }, [])
  
  async function GetProject() {
    const Now = DateHelper.取得當前時間();
    const str_dt = DateHelper.當前時間前後(Now,-6,'month');
    const end_dt = DateHelper.當前時間前後(Now,6,'month');
    const project_list: Project[] = await ProjectDAO.Select指定日期(str_dt, end_dt);
    set_projects(project_list);
  }
  const OnMenuOpen = (event: React.MouseEvent, menu_strip_name: string) => {
    if (MenuPosition) {
      return;
    }
    event.preventDefault();

    set_MenuName(menu_strip_name);// 標記要開啟的 Menu

    const rect = event.currentTarget.getBoundingClientRect();
    set_MenuPosition({ top: rect.top + rect.height, left: rect.left });// 左下角
  };
  if (_ProjectList === undefined) {
    return <Blocker />;
  }

  function render_ProjectList() {
    return (
      <Box style={linear_content_style} bgcolor={R.color.paper}>
        <Container sx={{ height: "100%", pb: 3, pt: 2 }} maxWidth={false}>
          <Grid {...linear_v}>
            <Grid {...linear_item} flex={1}>
              {render_DataGrid()}
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  return (
    <Box style={linear_content_style} >
      {/* 外框架 */}
      <Grid {...linear_h}>
        <Grid {...linear_item} width={0} bgcolor='#FFCCFF'>
          {/* 左側主檔 Master */}
          <Box bgcolor='#CCCCFF' >
          </Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor=''>
          {/* 中間列表 Details */}
          {render_Detail()}
        </Grid>
      </Grid>
    </Box >
  )

  function render_Detail() {
    return (<>
      <Grid {...linear_v}>
        <Grid {...linear_item}  >
          {render_AppBar()}
        </Grid>
        <Grid {...linear_item} flex={1}>
          <Box style={linear_content_style} sx={{}}>

            <TabPage tab_key={"Tab1"} curr_tab={AppBarTabIndex} sx={{ height: "100%", overflow: 'hidden' }}>
              <Box sx={{ height: "100%" }}>
                {render_ProjectList()}
              </Box>
            </TabPage>
          </Box>
        </Grid>
      </Grid>
    </>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position='static' sx={{ bgcolor: R.color.app_bar }} >
          <Toolbar variant='dense' >
            <AppMenuButton label={render_AppTitle()} />
            <Box sx={{ flexGrow: 1, }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {render_ActionButtons()}
          </Toolbar>
        </AppBar >
      </>
    );
  }

  function render_AppTitle() {
    return <Title variant='subtitle2'>{`請挑選與(${_Project?.project_name})共用的場次`}</Title>;
  }
  
  function 共用選擇場次() {
    try {      
      const sel_rows = grid_api.apiRef.current?.getSelectedRows();
      let sel_project_list: Project[] = [];
      sel_rows?.forEach(function (value, key) {
        let project = value as Project;
        sel_project_list.push(project);
      });
      
      if (sel_project_list.length === 0) {
        Toast.Show(ctx, "請先勾選場次");
        return;
      }
      for (let index = 0; index < sel_project_list.length; index++) {
        const sel_project = sel_project_list[index];
        if(_Project){
          ProjectDAO.Update_SetCid(sel_project,_Project.cid);
        }else{
          continue;
        }
      }
      alert("共用完成");
      
      ctx.Navigate(ROUTE_project_list.url);
    } catch (ex: any) {
      Toast.ShowDanger(ctx,`501746 ${ex.message}`);
    }
  }

  function render_ActionButtons() {
    return (
      <div>
        <IconButton size="large" edge="start" color="inherit" sx={{ ...sx_icon_button }}
          onClick={(e) => { 共用選擇場次()
          }}>
          <Label variant="button" sx={{ mx: 1 }}>共用選擇場次</Label>
        </IconButton>
        <IconButton onClick={(e) => OnMenuOpen(e, "Menu更多")} size={'small'} edge="start" color="inherit" sx={{ ...sx_icon_button }}        >
          {/* {render_Menu更多("Menu更多")} */}
          <MoreIcon />
        </IconButton>
      </div>
    );
  }


  function render_DataGrid() {
    return (
      <DataGrid
        components={{
          Toolbar: () => {
            return (<UcDgvCustomToolbar>
              <IconButton onClick={() => { Toast.Show(ctx, "More") }} ><MoreVertIcon /></IconButton>
            </UcDgvCustomToolbar>);
          },
          Pagination: () => {
            return <UcDgvCustomPagination />
          },
        }}

        localeText={DGV_LOCAL_TEXT}// 中文

        checkboxSelection={true}
        disableSelectionOnClick={true}

        style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
        getRowId={(data) => {
          return data.guid;
        }}
        rows={projects ?? []}
        columns={grid_api.columns}
        pageSize={100}
        rowsPerPageOptions={[100]}
      />
    );
  }

  function render_Menu更多(menu_name: string) {
    return (<Menu
      open={!!MenuPosition && MenuName === menu_name}
      onClose={() => set_MenuPosition(null)}
      anchorReference="anchorPosition"
      anchorPosition={MenuPosition}
    >
    </Menu>);
  }
};

export default FrmProjectMerge;
